/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Camera_Location_ChangeInputs */

const vi_camera_location_change = /** @type {(inputs: Camera_Location_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đổi vùng`)
};

/**

* @param {Camera_Location_ChangeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const camera_location_change = /** @type {((inputs?: Camera_Location_ChangeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Camera_Location_ChangeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_camera_location_change(inputs)
});